import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ScrollToTop from "./hooks/useScrollToTop";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/polityka-prywatnosci"
          element={<PrivacyPolicy lang="pl" />}
        />
        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy lang="en" />}
        />
      </Routes>
    </>
  );
}

export default App;